import React, { useCallback, useEffect, useRef, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { requestCanceller } from '../../service/axiosCancelToken';
import './SearchArchive.css';
import './Products';
import LoadingSpinner from '../Shared/LoadingSpinner';
import LoadingBar from '../Shared/ScrollLoadingBar';
import Product from './Product';
import { getProducts } from '../../service/menuOnlineService';

const SearchArchive = ({ searchInput, companyId, currencyType }) => {
    const [items, setItems] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const perPage = 30;
    const [onForceUpdate, setForceUpdate] = useState();
    const forceUpdate = useCallback(() => {
        setItems();
        setForceUpdate({});
    }, []);
    const [searchTimeout, setSearchTimeout] = useState(false);
    const timeOutRef = useRef(null);

    useEffect(() => {
        if (!searchInput) {
            return;
        }
        setSearchTimeout(true);
        clearTimeout(timeOutRef.current);
        timeOutRef.current = setTimeout(() => {
            forceUpdate();
            setSearchTimeout(false);
        }, 1000);
    }, [searchInput, forceUpdate])

    useEffect(() => {
        if (!searchInput) {
            return;
        }
        const cancelRequest = requestCanceller();


        const fetchAllProducts = async () => {
            try {
                const params = {
                    searchText: searchInput,
                    companyId,
                    perPage
                };
                let { status, data } = await getProducts(params, { cancelToken: cancelRequest.signal });
                if (status === 201)
                    setItems(prev => {
                        if (!prev || !prev.length) {
                            return data.items;
                        }
                        else {
                            let allitems = prev.concat(data.items);
                            return allitems;
                        }
                    })
                if (data.items.length < perPage) {
                    setHasMore(false);
                }
                setIsLoading(false);
            } catch (err) {
            }
        }

        fetchAllProducts();

        return () => {
            cancelRequest.cancel();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onForceUpdate]);




    return (
        <React.Fragment>
            <div className="products-layer" id="scrollableDiv">
                {
                    (!items || isLoading) ?
                        <React.Fragment>
                            {
                                (!searchInput || searchTimeout) ?
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        height: '70vh',
                                        color: "#eee",
                                        fontSize: '1.4rem'
                                    }}>
                                        <p>
                                            محصولی را جستجو کنید
                                        </p>
                                    </div>
                                    :
                                    <div style={{ height: '55vh' }}>
                                        <LoadingSpinner />
                                    </div>
                            }
                        </React.Fragment>
                        :
                        <React.Fragment>
                            {
                                !items.length ?
                                    <div className='Not-Exist' style={{ minHeight: '70vh' }}>
                                        موردی برای مشاهده وجود ندارد
                                    </div>
                                    :
                                    <InfiniteScroll
                                        dataLength={items && items.length}
                                        hasMore={hasMore}
                                        loader={
                                            <div className="infinite-scroll-loader">
                                                <span>
                                                    <LoadingBar
                                                        type="spinningBubbles"
                                                        color="rgb(238, 172, 4)"
                                                    />
                                                </span>
                                            </div>
                                        }
                                        scrollableTarget="scrollableDiv"
                                    >
                                        {
                                            items.map(item =>
                                                <Product
                                                    key={item._id}
                                                    data={item}
                                                    currencyType={currencyType}
                                                    companyId={companyId}
                                                />
                                            )
                                        }
                                    </InfiniteScroll>
                            }
                        </React.Fragment>
                }
            </div>
        </React.Fragment>
    );
}

export default SearchArchive;